/** Only current-world documents may be an account-flow return destination. */
const documents = new Set(['/', '/worlds/ssx', '/worlds/ssx/', '/direct/index.html']);
const legacyKeys = ['lobby', 'room', 'credits', 'session_id'];
const authKeys = ['auth', 'code', 'state', 'error', 'error_description', 'access_token', 'refresh_token', 'token_type', 'expires_in'];
export const ACCOUNT_RETURN_STATUSES = Object.freeze(['success', 'recovery', 'cancelled', 'expired', 'error']);
export function nativeAccountReturnPath(value = '/') {
  if (typeof value !== 'string' || value.length > 2048 || !value.startsWith('/') || value.startsWith('//') || /[\\\u0000-\u0020\u007f]/.test(value)) return '/';
  let url;
  try { url = new URL(value, 'https://valoria.invalid'); } catch { return '/'; }
  if (url.origin !== 'https://valoria.invalid' || !documents.has(url.pathname) || legacyKeys.some(key => url.searchParams.has(key))) return '/';
  for (const key of authKeys) url.searchParams.delete(key);
  return url.pathname + url.search;
}
export function accountReturnLocation(path, status) {
  const url = new URL(nativeAccountReturnPath(path), 'https://valoria.invalid');
  if (ACCOUNT_RETURN_STATUSES.includes(status)) url.searchParams.set('auth', status);
  return url.pathname + url.search;
}
export function currentNativeReturnPath(location = globalThis.location) {
  return nativeAccountReturnPath((location?.pathname || '/') + (location?.search || ''));
}
let pendingReturnStatus = null;
export function consumeAccountReturn(location = globalThis.location, history = globalThis.history) {
  const status = new URLSearchParams(location?.search || '').get('auth');
  if (!ACCOUNT_RETURN_STATUSES.includes(status)) return null;
  pendingReturnStatus = status;
  history?.replaceState(history.state ?? null, '', currentNativeReturnPath(location));
  return status;
}
export function takeAccountReturnStatus() {
  const status = pendingReturnStatus;
  pendingReturnStatus = null;
  return status;
}
